"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringDecoder = void 0;
const StreamMetadataDecoder_1 = require("../metadata/stream/StreamMetadataDecoder");
const IntegerDecoder_1 = require("./IntegerDecoder");
const textDecoder = new TextDecoder("utf-8");
class StringDecoder {
    /*
     * String column layouts:
     * -> plain -> present, length, data
     * -> dictionary -> present, length, dictionary, data
     * -> fsst dictionary -> symbolTable, symbolLength, dictionary, length, present, data
     * */
    static decode(data, offset, numStreams, presentStream, numValues) {
        let dictionaryLengthStream = null;
        let offsetStream = null;
        const dataStream = null;
        let dictionaryStream = null;
        /* eslint-disable @typescript-eslint/no-unused-vars */
        let symbolLengthStream = null;
        let symbolTableStream = null;
        for (let i = 0; i < numStreams; i++) {
            const streamMetadata = StreamMetadataDecoder_1.StreamMetadataDecoder.decode(data, offset);
            switch (streamMetadata.physicalStreamType()) {
                case 'OFFSET': {
                    offsetStream = IntegerDecoder_1.IntegerDecoder.decodeIntStream(data, offset, streamMetadata, false);
                    break;
                }
                case 'LENGTH': {
                    const ls = IntegerDecoder_1.IntegerDecoder.decodeIntStream(data, offset, streamMetadata, false);
                    if (streamMetadata.logicalStreamType().lengthType() === 'DICTIONARY') {
                        dictionaryLengthStream = ls;
                    }
                    else {
                        symbolLengthStream = ls;
                    }
                    break;
                }
                case 'DATA': {
                    const ds = data.slice(offset.get(), offset.get() + streamMetadata.byteLength());
                    offset.add(streamMetadata.byteLength());
                    if (streamMetadata.logicalStreamType().dictionaryType() === 'SINGLE') {
                        dictionaryStream = ds;
                    }
                    else {
                        symbolTableStream = ds;
                    }
                    break;
                }
                default:
                    console.log("StringDecoder encountered unknown stream type: " + streamMetadata.physicalStreamType());
                    return;
            }
        }
        if (symbolTableStream) {
            throw new Error("TODO: FSST decoding for strings is not yet implemented");
        }
        else if (dictionaryStream) {
            return this.decodeDictionary(presentStream, dictionaryLengthStream, dictionaryStream, offsetStream, numValues);
        }
        else {
            return this.decodePlain(presentStream, dictionaryLengthStream, dataStream, numValues);
        }
    }
    static decodePlain(presentStream, lengthStream, utf8Values, numValues) {
        const decodedValues = [];
        let lengthOffset = 0;
        let strOffset = 0;
        for (let i = 0; i < numValues; i++) {
            const present = presentStream.get(i);
            if (present) {
                const length = lengthStream[lengthOffset++];
                const value = textDecoder.decode(utf8Values.slice(strOffset, strOffset + length));
                decodedValues.push(value);
                strOffset += length;
            }
            else {
                decodedValues.push(null);
            }
        }
        return decodedValues;
    }
    static decodeDictionary(presentStream, lengthStream, utf8Values, dictionaryOffsets, numValues) {
        const dictionary = [];
        let dictionaryOffset = 0;
        for (const length of lengthStream) {
            const value = textDecoder.decode(utf8Values.slice(dictionaryOffset, dictionaryOffset + length));
            dictionary.push(value);
            dictionaryOffset += length;
        }
        const values = [];
        let offset = 0;
        for (let i = 0; i < numValues; i++) {
            const present = presentStream.get(i);
            if (present) {
                const value = dictionary[dictionaryOffsets[offset++]];
                values.push(value);
            }
            else {
                values.push(null);
            }
        }
        return values;
    }
}
exports.StringDecoder = StringDecoder;
//# sourceMappingURL=StringDecoder.js.map